import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import PurchasePage from './pages/PurchasePage';
import CustomerServicePage from './pages/CustomerServicePage';
import OrderPage from './pages/OrderPage';
import AuthPage from './pages/AuthPage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import DownloadPage from './pages/DownloadPage';
import DebugPage from './pages/DebugPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import AdminPage from './pages/AdminPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/purchase" element={<PurchasePage />} />
              <Route path="/customer-service" element={<CustomerServicePage />} />
              <Route path="/orders" element={<OrderPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/payment/:orderId" element={<PaymentPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/download" element={<DownloadPage />} />
              <Route path="/debug" element={<DebugPage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 